export enum ThemeType {
  Light = 'light',
  Dark = 'dark'
}
